import { useQuery } from 'query';

import { loadChart } from '../sources/loadChart';
import { chart } from './queryKeyFactory';

export const useChart = (params: any) => {
  return useQuery(chart(params), async () => {
    return loadChart(params);
  });
};
